import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const sessionTypeTemplateApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSessionTypeTemplates: builder.query({
      query: ({providerId, id, provider_id}) => {
        const qs = new URLSearchParams('');
        if (id) qs.set('id', id);
        return `session_type_template/?${qs}`;
      },
      providesTags: ['SessionTypeTemplate'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSessionTypeTemplatesQuery,
} = sessionTypeTemplateApi;